import React from "react";
import "./Topbar.css";
import { profile_img } from "../../assets/img/imgIndex";

const Topbar = () => {
  const userData = JSON.parse(localStorage.getItem("userId") || "{}");
  console.log("userData",userData);
  
  const userName = userData.name || "User";

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="menu-toggle">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="topbar-brand">
          <h2>Kadugudabba</h2>
          <p>Welcome back {userName}</p>
        </div>
      </div>

      <div className="topbar-right">
        <div className="user-profile">
          <div className="user-avatar">
            <img
              src={profile_img}
              alt="User"
            />
          </div>
          <div className="user-info">
            <p className="user-name">{userName}</p>
            <p className="user-role">Admin</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
